<template>
  <div>
    <div class="columns">
      <div class="column">
        <div :class="messageClass">
            {{message}}
        </div>
        <form v-on:submit.prevent="onDispense" autocomplete="off">
        <div class="field is-horizontal">
						<div class="field-label is-normal">
							<label class="label">Service</label>
						</div>
						<div class="field-body">
							<div class="field is-narrow">
								<div class="control">
									<div class="select is-fullwidth">
										<select v-model="service">
											<option value="ikedc">IKEDC</option>
											<option value="ekdc">ekdc</option>
											<option value="phdc">phdc</option>
											<option value="ibedc">ibedc</option>
											<option value="aedc">aedc</option>
											<option value="kedco">kedco</option>
											<option value="kaedco">kaedco</option>
											<option value="jed">jed</option>
										</select>
									</div>
								</div>
							</div>
						</div>
					</div>
            <div class="field">
                <label class="label">Account Number</label>
                <p class="control">
                    <input class="input" type="text" v-model="account">
                </p>
            </div>
            <div class="field">
                <label class="label">Amount</label>
                <p class="control">
                    <input class="input" type="number" v-model="amount">
                </p>
            </div>
            <div class="field is-grouped">
                <p class="control">
                    <button :class="submitClass">Dispense</button>
                </p>
            </div>         
        </form>   
      </div>
    </div>
    <div :class="modalClass">
      <div class="modal-background"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm Vending</p>
          <button class="delete" @click="closeModal"></button>
        </header>
        <section class="modal-card-body" v-if="dispenseData">

          <p><strong>Amount:</strong> {{dispenseData.amount}}</p>
          <p><strong>Name:</strong> {{dispenseData.identity.customerName}}</p>
          <p><strong>Account:</strong> {{dispenseData.identity.account}}</p>
          <p><strong>Address:</strong> {{dispenseData.identity.address}}</p>
<!-- 
          <button :class="submitClass" @click="doDispense">Complete Vending</button> -->
 
        </section>
        <footer class="modal-card-foot">
          <a class="button" @click="closeModal">Close</a>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
const url = "https://api.business.biya.com.ng/api/v1";
import axios from 'axios'
export default {
  name: 'hello',
  data () {
    return {
      service: '',
      account: '',
      amount: '',
      messageClass: 'is-hidden',
      message: '',
      submitClass: 'button is-success',
      modalClass: 'modal',
      dispenseData: null
    }
  },
  methods: {
    onDispense: function () {
        let self = this
        self.submitClass = "button is-success is-loading"
        if (!self.account) {
            self.submitClass = "button is-success"
            self.message = 'Missing parameter'
            self.messageClass = "notification is-danger"
            return;
        }
        axios({
            url: url + `/admin/retry`,
            baseURL: url,
            method: 'post',
            headers: {
                authorization: window.localStorage.getItem('biyadmin')
            },
            data: {
                serviceID: self.service,
                billersCode: self.account,
                amount: self.amount
            }
        })
        .then(function(result){
            self.submitClass = "button is-success"
            //  display modal
            self.dispenseData = result.data;
            self.modalClass = "modal is-active"
        })
        .catch(function(error){
            self.message = error.response.data.message ? error.response.data.message : 'There was an error'
            self.messageClass = "notification is-danger"
            self.submitClass = "button is-success"
            console.log(error)
        })
    },
    doDispense: function () {
        let self = this
        self.submitClass = "button is-success is-loading"
        if (!self.dispenseData) {
            self.submitClass = "button is-success"
            self.message = 'Missing parameter'
            self.messageClass = "notification is-danger"
            return;
        }
        axios({
            url: `/support/ikedc/2`,
            baseURL: url,
            method: 'post',
            data: { dispenseData: self.dispenseData }
        })
        .then(function(result){
            self.submitClass = "button is-success"
            //  display modal
            self.message = "Success"
            self.messageClass = "notification is-danger"
            self.modalClass = "modal"
        })
        .catch(function(error){
            self.message = error.response.data.message ? error.response.data.message : 'There was an error'
            self.messageClass = "notification is-danger"
            self.submitClass = "button is-success"
        })
    },
    closeModal: function () {
      this.modalClass = "modal"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


// WEBPACK FOOTER //
// IKEDC.vue?76ca1530